import Modal, { ModalSize } from "../../../../common/components/Modal";
import { useAddToCartWizardContext } from "../AddToCartWizard";
import AtcProductInfo from "../../v2/AtcProductInfo/AtcProductInfo";
import { useFormContext } from "react-hook-form";
import { type AddToCartFormData } from "../../../hooks/useAddToCartNew";
import OptimeSolutionsMessage from "../../../../common/components/Messages/OptimeSolutionsMessage";
import { PackagingSelection } from "../../../../common/components/PackagingSelection/PackagingSelection";
import {
  getCountriesListFromFifteendigit,
  isProductPMA,
} from "../../../../feature/ProductDescriptor/v1/productDescriptorUtils";
import { Permission, userHasPermission } from "../../../../utils/permissions";
import DisclaimerCountryOrigin from "../../../../common/components/Messages/DisclaimerCountryOrigin";
import { AutosuggestPackageRestrictionContext } from "~/common/components/PackageRestrictionContext/AutosuggestPackageRestrictionContext";
import { InfoProductMessagePMA } from "~/ProductDetails/components/ProductSummary/InfoProductMessagePMA";
import { Alert } from "~/common/m3/Alert/Alert";
import type { ProductDescriptor } from "~/feature/ProductDescriptor/v1/types";
import classNames from "classnames";
import AtcProductPriceInfo from "../../v2/AtcProductPriceInfo/AtcProductPriceInfo";
import { useIsMinTabletSize, useIsMinDesktopSize } from "../../../../common/hooks/useMediaQuery";

interface Props {
  productDescriptor: ProductDescriptor;
}

export const ConsumerViewAvailabilityModal = ({ productDescriptor }: Props) => {
  const { closePopup, getMainCls, t, getCloseBtn, restrictionQuery } = useAddToCartWizardContext();

  const isTablet = useIsMinTabletSize();
  const isDesktop = useIsMinDesktopSize();

  const { watch } = useFormContext<AddToCartFormData>();

  const quantity = watch("quantity");

  return (
    <AutosuggestPackageRestrictionContext productCode={productDescriptor.base.code} query={restrictionQuery}>
      <Modal
        size={isDesktop ? ModalSize.MEDIUM : ModalSize.TABLET}
        onClose={() => closePopup()}
        noPadding={!isTablet}
        modalClassName={"scha__add-to-cart-popup"}
        footerClassName={classNames(!isTablet && "scha__add-to-cart-popup-footer")}
        footerChildren={getCloseBtn(t("close"), !isTablet)}
      >
        <div className="scha__atc-popup__wrapper">
          <div className={classNames(getMainCls(), "scha__atc-popup-continer")}>
            <div className="scha__atc-product-info-wrapper">
              <AtcProductInfo descriptor={productDescriptor} />
            </div>
            <div className="scha__atc-popup--packaging-selection-notifications-wrapper">
              <div className="scha__atc-popup--column-packaging__wrapper scha__atc-popup--column-packaging">
                <div className="scha__atc-popup--column-packaging">
                  <div className="scha__atc-packaging-opts">
                    <div className="scha__atc-packaging-opts__title">{t("addToCartPopup.select.packaging.title")}</div>
                    <PackagingSelection selectedCode={""} product={productDescriptor} selectionType={"radio"} />
                  </div>
                </div>
                <AtcProductPriceInfo
                  quantity={null}
                  price={null}
                  onChange={() => {}}
                  priceUnit={1}
                  priceReference={""}
                  descriptor={productDescriptor}
                />
              </div>
              <div className="notifications scha__atc-popup--notifications">
                {isProductPMA(productDescriptor) && <InfoProductMessagePMA />}
                {userHasPermission(Permission.ADD_TO_CART) && (
                  <Alert severity="info" className="scha-atc__delivery-disclaimer">
                    {t("addToCartPopup.disclaimer")}
                  </Alert>
                )}
                {productDescriptor.base.isOptime && <OptimeSolutionsMessage />}
                {getCountriesListFromFifteendigit({ descriptor: productDescriptor }).length > 0 && (
                  <DisclaimerCountryOrigin />
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </AutosuggestPackageRestrictionContext>
  );
};
